import { createSlice } from '@reduxjs/toolkit';
import type { GroupId } from './types';

export interface StatisticsOptions {
  groups?: Record<GroupId, string[] | undefined>;
}

const initialState: StatisticsOptions = {
  groups: {},
};

const statisticsOptionSlice = createSlice({
  name: 'statisticsOption',
  initialState: initialState,
  reducers: {
    setOptions: (state, action) => {
      const { groups } = action.payload;
      if (groups !== undefined) {
        state.groups = groups;
      }
    },
  },
});

export default statisticsOptionSlice.reducer;
export const { setOptions } = statisticsOptionSlice.actions;
